export const randomString = (min: number, max: number) => {
  var result = "";
  const length = Math.random() * (max - min) + min;
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const randomNumber = (min: number, max: number) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const debounce = <Params extends any[]>(
  func: (...args: Params) => any,
  timeout: number
): ((...args: Params) => void) => {
  let timer: NodeJS.Timeout;
  return (...args: Params) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
};

export const round = (value: number, decimals: number) => {
  //@ts-ignore
  return Number(Math.round(value + "e" + decimals) + "e-" + decimals);
};

export const delay = async (timeInMs = 2500) => {
  await new Promise((resolve) => setTimeout(resolve, timeInMs));
};

export const isNumber = (value: any) => typeof value === "number";

export const arrayToChunks = <T>(array: T[], numOfChunks: number) => {
  const size =
    array.length % numOfChunks
      ? array.length / numOfChunks + 1
      : array.length / numOfChunks;
  let result = [];
  let arrayCopy = [...array];
  while (arrayCopy.length > 0) {
    result.push(arrayCopy.splice(0, size));
  }
  return result;
};
